import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import {
    MatLegacyCheckboxChange as MatCheckboxChange,
    MatLegacyCheckboxModule as MatCheckboxModule,
} from '@angular/material/legacy-checkbox';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialog as MatDialog,
    MatLegacyDialogConfig as MatDialogConfig,
    MatLegacyDialogModule as MatDialogModule,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatLegacyTable, MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment, { Moment } from 'moment';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, combineLatest, firstValueFrom, Observable, of, Subject, Subscription, switchMap } from 'rxjs';
import { filter, map, shareReplay, skip, take, takeUntil } from 'rxjs/operators';
import {
    BusinessVolumeCostStateEnum,
    BusinessVolumeEntity,
    BusinessVolumeStatusEnum,
    BusinessVolumeStatusEnumNameMap,
    BusinessVolumeTypeEnumNameMap,
} from '../../dave-data-module/entities/business-volume.entity';
import { CustomerEntity } from '../../dave-data-module/entities/customer.entity';
import { BVCustomNameResolver } from '../../dave-data-module/guards/b-v-custom-name.resolver';
import { BusinessVolumeResolver } from '../../dave-data-module/guards/business-volume.resolver';
import { CommissionResolver } from '../../dave-data-module/guards/commission.resolver';
import { FrontendDate } from '../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../dave-data-module/helper/helper';
import { State } from '../../dave-data-module/State';
import { BusinessVolumeActionTypes } from '../../dave-data-module/State/actions/business-volume.actions';
import { ChangeSettings } from '../../dave-data-module/State/actions/settings.actions';
import {
    getBVCustomNameFetched,
    getBVCustomNamesActive,
} from '../../dave-data-module/State/selectors/b-v-custom-name.selector';
import {
    getBusinessVolume,
    getBusinessVolumeById,
    getBusinessVolumeFetched,
} from '../../dave-data-module/State/selectors/business-volume.selector';
import {
    getChartOfAccounts,
    getChartOfAccountsFetched,
} from '../../dave-data-module/State/selectors/chartOfAccount.selectors';
import {
    getCommissionById,
    getCommissions,
    getCommissionsFetched,
} from '../../dave-data-module/State/selectors/commission.selector';
import { getPartner, getPartnerFetched } from '../../dave-data-module/State/selectors/partners.selectors';
import { getSetting, getSettingFetched } from '../../dave-data-module/State/selectors/users.selectors';
import {
    DaveFilePreviewComponent,
    DaveFilePreviewComponentDialogData,
} from '../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import { DaveListCardModule } from '../../dave-list-card/dave-list-card.module';
import { DaveLoadingModule } from '../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../dave-utils-module/app-filter-module/app-filter.module';
import {
    FILTER_TYPE_SEARCH_MULTI_SELECT,
    FILTER_TYPE_SEARCH_SELECT_BACKEND,
    FILTER_TYPE_SELECT,
    FILTER_TYPE_TIMESPAN,
    FilterOption,
    FilterOptionSelectSearch,
    IFilterTypeSearchMultiSelectValue,
} from '../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
    DaveSharedComponentsModule,
} from '../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PermissionService } from '../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { appMatDialogDefaultConfig, TableColumnConfig } from '../../helper/helper';
import { CustomLabelService } from '../../services/custom-label/custom-label.service';
import { DefaultFilterService, FilterApps, FilterTypes } from '../../services/default-filter.service';
import { LoadingService } from '../../services/loading.service';
import { TableConfigFormComponent } from '../../table-config-form/table-config-form.component';
import {
    BusinessVolumeDialogComponent,
    BusinessVolumeDialogComponentDialogData,
} from '../business-volume-dialog/business-volume-dialog.component';
import { ChartOfAccountResolver } from '../../dave-data-module/guards/chartOfAccount.resolver';
import { getLedgerImportsFetched } from 'src/app/dave-data-module/State/selectors/ledger-import.selector';
import {
    LedgerImportDocumentTypeCanHaveBusinessVolume,
    LedgerImportDocumentTypeNames,
} from 'src/app/dave-data-module/entities/ledger-import.entity';
import { LedgerImportResolver } from 'src/app/dave-data-module/guards/ledger-import.resolver';
import { isArray } from 'chart.js/helpers';
import { Permissions } from '@dave/types/dist/proto/global/permissions';
import { CommissionService } from '../../dave-commission-module/commission.service';
import { CustomerDataService } from '../../dave-data-module/services/customer-data.service';
import {
    BusinessVolumesDialogDatasource,
    BusinessVolumeTableItem,
    BvFilterValues,
} from './busines-volumes-dialog-datasource';
import {
    MatLegacyPaginator,
    MatLegacyPaginatorIntl as MatPaginatorIntl,
    MatLegacyPaginatorModule,
} from '@angular/material/legacy-paginator';
import { MatPaginatorWrapperComponent } from '../../mat-paginator-wrapper/mat-paginator-wrapper.component';
import { GermanPaginatorIntl } from '../../services/german-paginator-intl.service';

export interface ExportBusinessVolumeDialogComponentDialogData {
    Headline?: string;
    CommissionId?: number;
    CustomerId?: number;
    FilterValues?: BvFilterValues;
    Type?: BusinessVolumeCostStateEnum;
    Status?: BusinessVolumeStatusEnum[];
    FromDate: Moment;
    ToDate: Moment;
}
interface exportDataRequest{
    bvIds: number[];
    exportPeriodStart: Moment;
    exportPeriodEnd: Moment;
}






@Component({
    selector: 'app-business-volumes-dialog',
    templateUrl: './business-volumes-dialog.component.html',
    styleUrls: ['./business-volumes-dialog.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        AppButtonModule,
        FontAwesomeModule,
        MatMenuModule,
        MatTooltipModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        MatTableModule,
        MatCheckboxModule,
        DaveListCardModule,
        DaveLoadingModule,
        MatSortModule,
        ScrollingModule,
        TableVirtualScrollModule,
        MatBadgeModule,
        AppFilterModule,
        MatCardModule,
        DragDropModule,
        MatSidenavModule,
        TableConfigFormComponent,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatLegacyPaginatorModule,
        MatPaginatorWrapperComponent,
    ],
    providers: [
        {provide: MatPaginatorIntl, useClass: GermanPaginatorIntl},
    ],
})
export class BusinessVolumesDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatLegacyPaginator) paginator!: MatLegacyPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatLegacyTable) table!: MatLegacyTable<BusinessVolumeTableItem>;

    dataSource: BusinessVolumesDialogDatasource;
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        panelClass: ['custom-dialog-class-without-padding', 'custom-dialog-class-overflow-visible', ...appMatDialogDefaultConfig.panelClass],
        width: '92vw',
        maxWidth: '100vw',
        maxHeight: '95vh',
    };


    public TableColumns$: Observable<TableColumnConfig<BusinessVolumeTableItem>[]> = combineLatest([
        this.cls.getSingle$('CustomerSupplier'),
        this.cls.getSingle$('Commission'),
        this.cls.getSingle$('CustomerNumberShort'),
    ]).pipe(map(([customerLabel, commissionLabel, customerNoLabel]) => {
        return [
            { header: customerLabel, name: 'customerName' },
            { header: customerNoLabel + '/Konto Nr.', name: 'customerNr_KontoNr' },
            { header: commissionLabel, name: 'commission' },
            { header: 'Name', name: 'name' },
            { header: 'Typ', name: 'type' },
            { header: 'Dokumenten Typ', name: 'ledgerImportDocType' },
            { header: 'Art', name: 'bVCustomNames' },
            { header: 'Beschreibung', name: 'description' },
            { header: 'Geschäftsvolumen-Nr.', name: 'businessVolumeNo' },
            { header: 'Status', name: 'status' },
            { header: 'Betrag netto', name: 'amount' },
            { header: 'Bezahlter Betrag netto', name: 'payedAmount' },
            { header: 'Erstellt am', name: 'createdAt' },
            { header: 'Rechnungsdatum', name: 'consolidatedDate' },
            { header: 'Leistungsdatum', name: 'consolidatedDeliveryDate' },
            { header: 'Fälligkeitsdatum', name: 'dueDate' },
            { header: 'Exportiertes Datum', name: 'exportDate' },
            { header: 'Export-Zeitraum', name: 'exportTimespan' },
            { header: 'Letztes Zahlungsdatum', name: 'lastPaymentDate' },
            { header: 'Letzte Zahlungs Notiz', name: 'lastPaymentNote' },
            { header: 'Letzter Zahlungsbetrag Brutto', name: 'lastPaymentGross' },
            { header: 'Letzter Zahlungsbetrag Netto', name: 'lastPaymentNet' },
            { header: 'Bezahlter Betrag brutto', name: 'payedAmountGross' },
            { header: 'Betrag brutto', name: 'amountGross' },
            { header: 'Skonto netto', name: 'discountValue' },
            { header: 'Skonto brutto', name: 'discountValueGross' },
        ];
    }))

    public availableColumns = [
        'customerName',
        'customerNr_KontoNr',
        'commission',
        'name',
        'type',
        'ledgerImportDocType',
        'bVCustomNames',
        'description',
        'businessVolumeNo',
        'status',
        'amount',
        'payedAmount',
        'createdAt',
        'consolidatedDate',
        'consolidatedDeliveryDate',
        'dueDate',
        'exportDate',
        'exportTimespan',
        'lastPaymentDate',
        'lastPaymentNote',
        'lastPaymentGross',
        'lastPaymentNet',
        'payedAmountGross',
        'amountGross',
        'discountValue',
        'discountValueGross',
    ];
    public displayedColumns: string[];
    public selectedColumns$: Observable<(keyof BusinessVolumeTableItem)[]>;
    public disabledColumns$: Observable<number>;
    public TableColumnsSorted$: Observable<TableColumnConfig<BusinessVolumeTableItem>[]>;

    public SelectedBvs$ = new BehaviorSubject<BusinessVolumeEntity[]>([]);
    public selection = new SelectionModel<BusinessVolumeTableItem>(true, []);
    private CommissionId$ = new BehaviorSubject<number | null>(null);
    private CustomerId$ = new BehaviorSubject<number>(null);

    public Multiselect = false;

    protected canCreateBV$ = this.ps.Has$(Permissions.CreateBusinessVolume).pipe(switchMap(has => has ? of(true) : this.CommissionId$.pipe(switchMap(cId => this.commissionService.entityRolePermissions$(cId)), map(permissions => permissions.includes(Permissions.CreateBusinessVolume)))));
    @Input() set commissionId(id: number | null) {
        this.CommissionId$.next(id);
    }

    get commissionId() {
        return this.CommissionId$.value;
    }

    @Input() set customerId(id: number | null) {
        this.CustomerId$.next(id);
    }

    get customerId() {
        return this.CustomerId$.value;
    }

    @ViewChild('searchInput') searchInput: ElementRef;
    protected readonly BusinessVolumeCostStateEnum = BusinessVolumeCostStateEnum;
    protected searchForm = new FormControl<string>('');
    protected searchVisible = false;
    private subs: Subscription[] = [];
    private onDestroy$ = new Subject<void>();
    protected allSelected$: Observable<boolean>;
    constructor(
        @Inject(MAT_DIALOG_DATA) public DialogData: ExportBusinessVolumeDialogComponentDialogData,
        @Optional() protected dialogRef: MatDialogRef<BusinessVolumesDialogComponent>,
        private store: Store<State>,
        protected dialog: MatDialog,
        protected ls: LoadingService,
        protected commissionResolver: CommissionResolver,
       // protected customerResolver: CustomerResolver,
        protected chartOfAccountResolver: ChartOfAccountResolver,
        protected cls: CustomLabelService,
        protected bvsResolver: BusinessVolumeResolver,
        protected ledgerimportResolver: LedgerImportResolver,
        private actions$: Actions,
        private apiToasterService: ToastrService,
        private bVCustomNameResolver: BVCustomNameResolver,
        private ps: PermissionService,
        private defaultFilterService: DefaultFilterService,
        private commissionService: CommissionService,
        private customerDataService: CustomerDataService,
    ) {
        this.dataSource = new BusinessVolumesDialogDatasource(this.BVS$);
        this.dataSource.filter$ = this.BvFilterValues$;
        this.subs.push(
            this.searchForm.valueChanges.subscribe(search => {
                this.dataSource.searchQuery$.next(search);
            })
        );
        if (DialogData) {
            this.commissionId = DialogData.CommissionId;
            this.customerId = DialogData.CustomerId;
            if(DialogData.FilterValues){
                this.BvFilterValues$.next({...this.BvFilterValues$.value, ...DialogData.FilterValues});
            }
        }
        firstValueFrom(this.store.select(getBVCustomNameFetched)).then((f) => {
            if (!f) {
                this.bVCustomNameResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getLedgerImportsFetched)).then((f) => {
            if (!f) {
                this.ledgerimportResolver.resolve();
            }
        });
        this.BvFilterValues$.pipe(takeUntil(this.onDestroy$), skip(2)).subscribe((val) => {
            if (Object.keys(val).length !== 0) {
                this.defaultFilterService.SetFilterByApp(FilterApps.BvsList, val);
            }
        });

        this.selectedColumns$ = combineLatest([getFetched$(this.store, getSettingFetched, getSetting), getFetched$(this.store, getPartnerFetched, getPartner)]).pipe(
            map(([settings, partner]) => {
                let columns: string[];
                if (settings.ExportBusinessVolumesDialogComponentDisplayedColumns) {
                    columns = settings.ExportBusinessVolumesDialogComponentDisplayedColumns;
                } else if (partner.AdditionalData?.ExportBusinessVolumesDialogComponentDisplayedColumns) {
                    columns = partner.AdditionalData.ExportBusinessVolumesDialogComponentDisplayedColumns;
                } else {
                    columns = this.availableColumns;
                }
                return columns.filter((col) => this.availableColumns.includes(col)) as (keyof BusinessVolumeTableItem)[];
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
        );

        this.TableColumnsSorted$ = combineLatest([
            this.selectedColumns$,
            this.TableColumns$,
        ]).pipe(map(([selected, columns]) => {
            return columns.sort((a, b) => selected.indexOf(a.name) - selected.indexOf(b.name));
        }));

        this.disabledColumns$ = combineLatest([this.TableColumnsSorted$, this.selectedColumns$]).pipe(map(([all, selected]) => all.length - selected.length || undefined));

        this.allSelected$ = combineLatest([this.dataSource.currentFilteredData$, this.SelectedBvs$]).pipe(
            map(([data, selected]) => {
                  const selectedIds = new Set(selected.map((bv) => bv.Id));
                  return selectedIds.size === data.length && data.every((row) => selectedIds.has(row.bvEntity.Id));
            }),
            shareReplay({refCount: true, bufferSize: 1}),
        );
    }

    ngOnInit(): void {
        this.subs.push(
            this.selectedColumns$.subscribe((columns) => {
                this.availableColumns = columns;
                this.displayedColumns = columns.slice();
            }),
        );

       this.defaultFilterService.GetFilterByApp$(FilterApps.BvsList)
            .pipe(take(1))
            .subscribe((filterValues) => {
                let customer = filterValues[FilterTypes.Customers]
                if (isArray(customer)) {
                    if (customer.length === 0) {
                        customer = null;
                    } else {
                        customer = customer[0];
                    }
                }
                this.BvFilterValues$.next({
                    [FilterTypes.Commissions]: filterValues[FilterTypes.Commissions] && isArray(filterValues[FilterTypes.Commissions]) ? filterValues[FilterTypes.Commissions] as IFilterTypeSearchMultiSelectValue<number>[] : [],
                    [FilterTypes.Customers]: customer,
                    [FilterTypes.ContraChartOfAccounts]: filterValues[FilterTypes.ContraChartOfAccounts] && isArray(filterValues[FilterTypes.ContraChartOfAccounts]) ? filterValues[FilterTypes.ContraChartOfAccounts] as IFilterTypeSearchMultiSelectValue<number>[] : [],
                    [FilterTypes.Date]: filterValues[FilterTypes.Date] ? { from: filterValues[FilterTypes.Date].from && moment(filterValues[FilterTypes.Date].from), to: filterValues[FilterTypes.Date].to && moment(filterValues[FilterTypes.Date].to) } : null,
                    [FilterTypes.ConsolidatedDate]: filterValues[FilterTypes.ConsolidatedDate] ? { from: filterValues[FilterTypes.ConsolidatedDate].from && moment(filterValues[FilterTypes.ConsolidatedDate].from), to: filterValues[FilterTypes.ConsolidatedDate].to && moment(filterValues[FilterTypes.ConsolidatedDate].to) } : null,
                    [FilterTypes.DueDate]: filterValues[FilterTypes.DueDate] ? { from: filterValues[FilterTypes.DueDate].from && moment(filterValues[FilterTypes.DueDate].from), to: filterValues[FilterTypes.DueDate].to && moment(filterValues[FilterTypes.DueDate].to) } : null,
                    [FilterTypes.Status]: filterValues[FilterTypes.Status] && isArray(filterValues[FilterTypes.Status]) && this.DialogData.Status == undefined ? filterValues[FilterTypes.Status] as IFilterTypeSearchMultiSelectValue<string>[] : [],
                    [FilterTypes.CustomNames]: filterValues[FilterTypes.CustomNames] && isArray(filterValues[FilterTypes.CustomNames]) ? filterValues[FilterTypes.CustomNames] as IFilterTypeSearchMultiSelectValue<string>[] : [],
                    [FilterTypes.Export]: filterValues[FilterTypes.Export] ? filterValues[FilterTypes.Export] : null,
                    [FilterTypes.Checked]: filterValues[FilterTypes.Checked] ? filterValues[FilterTypes.Checked] : null,
                    [FilterTypes.Type]:  filterValues[FilterTypes.Type] && this.DialogData.Type == undefined ? filterValues[FilterTypes.Type] as BusinessVolumeCostStateEnum: null,
                    [FilterTypes.LedgerImportDocTypes]: filterValues[FilterTypes.LedgerImportDocTypes] && isArray(filterValues[FilterTypes.LedgerImportDocTypes]) ? filterValues[FilterTypes.LedgerImportDocTypes] as IFilterTypeSearchMultiSelectValue<string>[] : [],
                    /**
                     * subcommissions sollen nicht aus dem service gespeichert werden, da sonst die Filterlogik kaput geht, falls keine oder nicht die passende CommissionId übergeben wurde
                     */
                    [FilterTypes.SubCommissions]: this.BvFilterValues$.value[FilterTypes.SubCommissions] || [],

                    ...this.DialogData.FilterValues,
                });
            });
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.table.dataSource = this.dataSource;
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.subs.forEach((s) => s.unsubscribe());
    }

    ToggleMultiselect() {
        this.Multiselect = !this.Multiselect;
        this.SelectedBvs$.next([]);
        if (this.availableColumns.includes('select')) {
            this.availableColumns.splice(this.availableColumns.indexOf('select'), 1);
        } else {
            this.availableColumns.unshift('select');
        }
    }

    private BVS$ = combineLatest([
        getFetched$(this.store, getBusinessVolumeFetched, getBusinessVolume, this.bvsResolver),
        getFetched$(this.store, getCommissionsFetched, getCommissions, this.commissionResolver),
    ]).pipe(
        map(([bvs, commissions]) => {
            const validBvs = bvs.filter((bv) => {
                const dateToCheck = bv.ConsolidatedDate || bv.CreatedAt;
                if (this.DialogData?.FromDate && this.DialogData?.ToDate) {
                    return this.DialogData.FromDate.isSameOrBefore(dateToCheck) && this.DialogData.ToDate.isSameOrAfter(dateToCheck);
                } else {
                    return bv
                }
            });
            const validCommissionIds = this.DialogData?.CommissionId ? [this.DialogData.CommissionId, ...commissions.filter(c => c.ParentId === this.DialogData.CommissionId).map(c => c.Id)] : null;

            return validBvs.filter((bv) => {
                return (!(this.DialogData?.CustomerId) || bv.CustomerId === this.DialogData.CustomerId) &&
                (!validCommissionIds || validCommissionIds.includes(bv.CommissionId)) &&
                (!(this.DialogData?.Type) || bv.BVType === this.DialogData.Type) &&
                (!(this.DialogData?.Status) || this.DialogData.Status.includes(bv.Status));
            }).sort((a,b) => new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime());
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public BvFilterSettings: Observable<FilterOption<keyof BvFilterValues>[]> = combineLatest([
        this.store.select(getBVCustomNameFetched).pipe(
            filter((f) => f),
            switchMap(() => this.store.select(getBVCustomNamesActive)),
        ),
        getFetched$(this.store, getCommissionsFetched, getCommissions, this.commissionResolver),
        this.CommissionId$,
        this.CustomerId$,
        this.cls.getMultiple$('Commission'),
        this.cls.getMultiple$('CustomerSupplier'),
        getFetched$(this.store, getChartOfAccountsFetched, getChartOfAccounts, this.chartOfAccountResolver),
    ]).pipe(
        map(([customNames, commissions, commissionId, customerId, commissionLabel, customerLabel, coas]) => {
            const filters: FilterOption<keyof BvFilterValues>[] = [];
            if (!customerId) {
                let customerState = this.customerDataService.createSearchState();
                filters.push({
                    Name: FilterTypes.Customers,
                    Type: FILTER_TYPE_SEARCH_SELECT_BACKEND,
                    Label: customerLabel,
                    SelectSearch: {
                        options$: customerState.customerOptions$,
                            loading$: customerState.loading$,
                            pageIndex$:  customerState.customerPaging.pageIndex$,
                            pageCount$: customerState.customerPaging.pageCount$,

                            getIdFromValue: (c) => c.Id,
                            getValueFromId: (id) => this.customerDataService.GetSingleCustomer$(id),

                            serverSearch: (search) => customerState.SearchCustomers(search, 'unbenannter ' + customerLabel),
                            pageChange: (event) => customerState.customerPageChange(event),
                            compareOptions: (a, b) => a?.Id === b?.Id,
                    } as FilterOptionSelectSearch<CustomerEntity>,
                });
            }
            if (!commissionId) {
                const filterValues: IFilterTypeSearchMultiSelectValue[] = commissions.map((r) => ({
                    label: r.optionLabel,
                    id: r.Id,
                }));
                filters.push({
                    Name: FilterTypes.Commissions,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: commissionLabel,
                    Values: filterValues,
                });
            }
            if (commissionId) {
                const filterValues: IFilterTypeSearchMultiSelectValue[] = commissions.filter(c => c.ParentId === commissionId || c.Id === commissionId).map((r) => ({
                    label: r.optionLabel,
                    id: r.Id,
                }));
                if (filterValues.length) {
                    filters.push({
                        Name: FilterTypes.SubCommissions,
                        Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                        Label: commissionLabel,
                        Values: filterValues,
                    });
                }
            }
            filters.push(
                {
                    Name: FilterTypes.Date, //CreatedAt
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Erstellt',
                },
                {
                    Name: FilterTypes.ConsolidatedDate,
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Rechnungsdatum',
                },
                {
                    Name: FilterTypes.DueDate,
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Fälligkeitsdatum',
                },
                {
                    Name: FilterTypes.LedgerImportDocTypes,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Dokument Typ',
                    Values: Array.from(LedgerImportDocumentTypeNames.keys())
                    .filter((key) => LedgerImportDocumentTypeCanHaveBusinessVolume(key))
                    .map<IFilterTypeSearchMultiSelectValue<string>>((v) =>
                        ({
                        id: v,
                        label: LedgerImportDocumentTypeNames.get(v),
                        })
                    ),
                },
            )
            if(!this.DialogData.Type) {
                filters.push({
                    Name: FilterTypes.Type,
                    Type: FILTER_TYPE_SELECT,
                    Label: 'Typ',
                    Values: {
                        [BusinessVolumeCostStateEnum.Income]: BusinessVolumeTypeEnumNameMap.get(BusinessVolumeCostStateEnum.Income),
                        [BusinessVolumeCostStateEnum.Costs]: BusinessVolumeTypeEnumNameMap.get(BusinessVolumeCostStateEnum.Costs),
                    },
                });
            }
            filters.push(
                {
                    Name: FilterTypes.Export,
                    Type: FILTER_TYPE_SELECT,
                    Label: 'Exportiert',
                    Values: {
                        false: 'Nein',
                        true: 'Ja',
                    },
                },
                {
                    Name: FilterTypes.Checked,
                    Type: FILTER_TYPE_SELECT,
                    Label: 'Geprüft',
                    Values: {
                        false: 'Nein',
                        true: 'Ja',
                    },
                },
            )
            if(!this.DialogData.Status) {
                filters.push({
                    Name: FilterTypes.Status,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Status',
                    Values: Array.from(BusinessVolumeStatusEnumNameMap.keys()).map<IFilterTypeSearchMultiSelectValue<string>>((v) => ({
                        id: v,
                        label: BusinessVolumeStatusEnumNameMap.get(v),
                    })),
                });
            }
            filters.push(
                {
                    Name: FilterTypes.CustomNames,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Art',
                    Values: customNames.map((r) => ({
                        label: r.Name,
                        id: r.Id,
                    })),
                },
            );
            const filterValues: IFilterTypeSearchMultiSelectValue[] = coas.map((r) => ({
                label: r.Name+ " / "+ r.Number,
                id: r.Id,
            }));
            filters.push({
                Name: FilterTypes.ContraChartOfAccounts,
                Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                Label: "Sachkonto",
                Values: filterValues,
            });
            return filters;
        }),
    );

    public BvFilterValues$: BehaviorSubject<BvFilterValues> = new BehaviorSubject({
        [FilterTypes.Status]: [],
        [FilterTypes.CustomNames]: [],
        [FilterTypes.Export]: null,
        [FilterTypes.Checked]: null,
        [FilterTypes.Type]: null,
        [FilterTypes.LedgerImportDocTypes]: [],
        [FilterTypes.Commissions]: [],
        [FilterTypes.Customers]: null,
        [FilterTypes.ContraChartOfAccounts]: [],
        [FilterTypes.Date]: {from: null, to: null},
        [FilterTypes.ConsolidatedDate]: {from: null, to: null},
        [FilterTypes.DueDate]: {from: null, to: null},
        [FilterTypes.SubCommissions]: [],
    });



    public FilterAmount$ = this.BvFilterValues$.pipe(
        map((filter) => {
            const hasDateRange = (value: { from?: any; to?: any } | null | undefined) =>
                !!value && (value.from || value.to);

            let amount = 0;
            if (filter[FilterTypes.Status]?.length) {
                amount += 1;
            }
            if (filter[FilterTypes.Customers] !== null) {
                amount += 1;
            }
            if (filter[FilterTypes.Commissions]?.length) {
                amount += 1;
            }
            if (filter[FilterTypes.SubCommissions]?.length) {
                amount += 1;
            }
            if (hasDateRange(filter[FilterTypes.Date])) {
                amount += 1;
            }
            if (hasDateRange(filter[FilterTypes.ConsolidatedDate])) {
                amount += 1;
            }
            if (hasDateRange(filter[FilterTypes.DueDate])) {
                amount += 1;
            }
            if (filter[FilterTypes.Type] != null && filter[FilterTypes.Type] !== undefined) {
                amount += 1;
            }
            if (Array.isArray(filter[FilterTypes.LedgerImportDocTypes]) && filter[FilterTypes.LedgerImportDocTypes].length > 0) {
                amount += 1;
            }
            if (Array.isArray(filter[FilterTypes.CustomNames]) && filter[FilterTypes.CustomNames].length > 0) {
                amount += 1;
            }
            if (filter[FilterTypes.ContraChartOfAccounts]?.length) {
                amount += 1;
            }
            if (filter[FilterTypes.Export] !== null && filter[FilterTypes.Export] !== undefined) {
                amount += 1;
            }
            if (filter[FilterTypes.Checked] !== null && filter[FilterTypes.Checked] !== undefined) {
                amount += 1;
            }
            return amount;
        }),
    );

    IsSelected = (rowData: BusinessVolumeTableItem) => this.SelectedBvs$.getValue().findIndex((v) => v.Id === rowData.bvEntity.Id) > -1;

    validSettlementDate(rowData: BusinessVolumeTableItem): boolean {
        let valid = true;
        if(rowData.dueDate) {
            this.subs.push(
                this.store.select(getBusinessVolumeById({id: rowData.id})).subscribe((b) => {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    valid = today.getTime() < b.DueDate.getTime() || b.Status === BusinessVolumeStatusEnum.Payed || b.Status === BusinessVolumeStatusEnum.Booked;
                }),
            );
            return valid
        } else {
            return valid;
        }
    }

    CheckBoxSelectBv(event: MatCheckboxChange, rowData: BusinessVolumeTableItem) {
        const currentSelected = this.SelectedBvs$.getValue();
        let newSelected = [...currentSelected];
        const index = newSelected.findIndex((v) => v.Id === rowData.bvEntity.Id);

        if (!event.checked && index > -1) {
            newSelected.splice(index, 1);
        } else if (event.checked && index === -1) {
            newSelected.push(rowData.bvEntity);
        }
        this.SelectedBvs$.next(newSelected);
    }

    async toggleAllSelections() {
        const isAllSelected = await firstValueFrom(this.allSelected$);

        if (isAllSelected) {
            this.SelectedBvs$.next([]);
        } else {
            this.SelectedBvs$.next(this.dataSource.currentFilteredData$.value.map((row) => row.bvEntity));
        }
    }


    openEditDialog(rowData?: BusinessVolumeTableItem) {
        let id = rowData.id;
        firstValueFrom(this.store.select(getBusinessVolumeById({ id }))).then((bve) => {
            this.dialog.open<BusinessVolumeDialogComponent, BusinessVolumeDialogComponentDialogData>(BusinessVolumeDialogComponent, {
                ...BusinessVolumeDialogComponent.DefaultConfig,
                data: {
                    BvId: id,
                    ShowCommissionForm: !this.CommissionId$.value,
                    ShowCustomerForm: !this.CustomerId$.value,
                },
                autoFocus: !id,
            });
        });
    }

    async exportAll() {
        const data = this.dataSource.currentFilteredData$.value;
        this.SelectedBvs$.next(data.map((row) => row.bvEntity));

        await this.export();
    }

   async export() {
        this.ls.startLoading('export-businessVolumes-csv');
        firstValueFrom(this.actions$.pipe(ofType(BusinessVolumeActionTypes.ExportFailure, BusinessVolumeActionTypes.ExportSuccess))).then((action) => {
            this.ls.endLoading('export-businessVolumes-csv');
            if (action.type === BusinessVolumeActionTypes.ExportSuccess.type) {
                this.apiToasterService.success('erfolgreich exportiert');
                this.dialogRef.close();
                this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
                    ...DaveFilePreviewComponent.DefaultConfig,
                    data: {
                        fileId: action.Payload.Id,
                    },
                });
            }
        });
       let fromDate: Date = this.DialogData?.FromDate?.toDate();
       let toDate: Date = this.DialogData?.ToDate?.toDate();
       if (!fromDate || !toDate) {
           const filterValue = await firstValueFrom(this.BvFilterValues$)
           if (filterValue && filterValue[FilterTypes.ConsolidatedDate]?.to && filterValue[FilterTypes.ConsolidatedDate]?.from) {
               fromDate = filterValue[FilterTypes.ConsolidatedDate].from.toDate();
               toDate = filterValue[FilterTypes.ConsolidatedDate].to.toDate();
           } else {
               this.SelectedBvs$.getValue().map((bv) => {
                   const date = bv?.ConsolidatedDate ? bv.ConsolidatedDate : bv.CreatedAt;
                   fromDate = fromDate && fromDate.getTime() < date.getTime() ? fromDate : date;
                   toDate = toDate && toDate.getTime() > date.getTime() ? toDate : date;
               })
           }
       }
       if (!fromDate || !toDate) {
           fromDate = new Date();
           toDate = new Date();
       }
       fromDate.setHours(0, 0, 0, 0);
       toDate.setHours(23, 59, 59, 999);
       this.store.dispatch(
           BusinessVolumeActionTypes.ExportRequest({
               Payload: {
                   startDate: this.DialogData?.FromDate ? FrontendDate(this.DialogData.FromDate.toDate(), true) : FrontendDate(fromDate, true),
                   endDate: this.DialogData?.ToDate ? FrontendDate(this.DialogData.ToDate.toDate(), true) : FrontendDate(toDate, true),
                   bvIds: this.SelectedBvs$.getValue().map((bv) => bv.Id),
               },
           }),
       );
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousIndex !== event.currentIndex) {
            const updatedColumns = [...this.availableColumns];
            moveItemInArray(updatedColumns, event.previousIndex, event.currentIndex);
            this.availableColumns = updatedColumns;
            this.displayedColumns = this.availableColumns.slice();
            this.saveColumnOrder();
        }
    }

    saveColumnOrder() {
        this.store.dispatch(
            new ChangeSettings({
                ExportBusinessVolumesDialogComponentDisplayedColumns: this.availableColumns,
            }),
        );
    }

    selectedColumnsChange(selectedColumns: Array<keyof BusinessVolumeTableItem>) {
        this.store.dispatch(
            new ChangeSettings({
                ExportBusinessVolumesDialogComponentDisplayedColumns: selectedColumns,
            }),
        );
        this.availableColumns = selectedColumns;
        this.displayedColumns = selectedColumns.slice();
    }

    async addBV() {
        const customerId = this.customerId;
        const commissionId = this.commissionId;

        let customer: CustomerEntity;
        if (customerId) {
            customer = await firstValueFrom(this.customerDataService.GetSingleCustomer$(customerId));
        } else if (commissionId) {
            const commission = await firstValueFrom(getFetched$(this.store, getCommissionsFetched, getCommissionById({ id: commissionId }), this.commissionResolver));
            if (commission?.CustomerId) {
                customer = await firstValueFrom(this.customerDataService.GetSingleCustomer$(commission.CustomerId));
            }
        }
        this.dialog.open<BusinessVolumeDialogComponent, BusinessVolumeDialogComponentDialogData>(BusinessVolumeDialogComponent, {
            ...BusinessVolumeDialogComponent.DefaultConfig,
            data: {
                BvId: undefined,
                ShowCommissionForm: !commissionId,
                ShowCustomerForm: !customerId,
                AddBusinessVolumeDefaultValues: { commissionId, customerId, sachkontoCOAId: customer?.SachkontoCOAId },
            },
            autoFocus: true,
        });
    }

    toggleSearch() {
        this.searchVisible = !this.searchVisible;
        this.searchForm.setValue('');
        if (this.searchVisible) {
            setTimeout(() => {
                this.searchInput.nativeElement.focus();
            }, 0);
        }
    }
}



